import { Component, Input, OnInit } from '@angular/core'
import { NgControl } from '@angular/forms'
import { TranslateService } from '@ngx-translate/core'
import { ErrorMessage } from './error-message'

@Component({
  selector: 'lin-form-field-error',
  templateUrl: './form-field-error.component.html',
  styles: [
    `
      .mat-mdc-form-field-error {
        display: block;
        margin-top: 4px;
      }
    `,
  ],
  standalone: false,
})
export class FormFieldErrorComponent implements OnInit {
  @Input() control: NgControl | null = null
  @Input() controlName!: string

  constructor(private translateService: TranslateService) {}

  get message(): string {
    if (!this.control || !this.control.errors || !this.controlName) {
      return ''
    }
    return new ErrorMessage(this.control, this.translateService, this.controlName).first || ''
  }

  ngOnInit(): void {
    if (!this.control || !this.controlName) {
      console.warn(
        `FormFieldErrorComponent issue: control=${this.control}, controlName=${
          this.controlName || 'unknown'
        }. Ensure [control] and controlName inputs are set.`,
        {
          component: this,
          parentElement: (this as any).__ngContext__?.nativeElement?.parentElement,
        },
      )
    }
  }
}
